




















import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import UploadForm from './UploadForm.vue'
import { uploadStatus } from '@/api/studentPhoto/studentPhoto'
@Component({
    components: { UploadForm }
})
export default class UploadStatus extends Vue {

    loading = false

    handleUploadStatus = uploadStatus

    @Emit('clickReturn')
    onReturn($event: any) {
        return $event
    }

    success() {
        this.$emit('SaveSuccess')
    }
}
